import { BROADCAST_SET_SERVER_TIME_DELTA } from 'actions/Types';

export default (state = 0, action) => {
  if (action.type === BROADCAST_SET_SERVER_TIME_DELTA) return action.payload;

  return state;
};
